module.exports = __webpack_public_path__ + "images/commercial-icon-3fce99b4227a2042740cf75cc3e8d9b7.svg";